import React, { useState, useEffect } from 'react';
import ApiService from '../../functions/apiService';
import {
  Paper, Grid, Typography, TextField, Autocomplete, Box,
  IconButton, Divider, Card, CardContent
} from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import Multiselect from 'multiselect-react-dropdown';

const inputSx = {
  "& .MuiInputBase-root": {
    height: "48px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center"
  }
};

const AddStationChecklist = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [duration, setDuration] = useState("");
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState("");
  const [time, setTime] = useState(null);
  const [assignedTo, setAssignedTo] = useState(null);
  const [ticketAssignTo, setTicketAssignTo] = useState(null);
  const [ticketNotifyTo, setTicketNotifyTo] = useState([]);
  const [checklistUpdateTo, setChecklistUpdateTo] = useState(null);
  const [positionDrop , setPositionDrop] = useState([]);
  const [position , setPosition] = useState(null);
  const [locationDrop, setLocationDrop] = useState([]);
  const [items, setItems] = useState([{ category: "", description: "", location_id: "" }]);

  const navigate = useNavigate();

  const loadEmployees = () => {
    ApiService.get('/employee-list-inventory')
      .then(({ data }) => {
        const tempArr = data.data.map((emp) => ({
          label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
          value: emp.Emp_Code
        }));
        setEmployees(tempArr);
      })
      .catch(() => {});
  };

  useEffect(() => {
    loadEmployees();
  }, []);

  const getPositionDropown = () => {
    ApiService.get('/positions-list')
      .then(({ data }) => {
        var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
        setPositionDrop(certArr)
      })
      .catch((e) => {
        console.error(e || 'error')
      })
  }

  useEffect(() => {
    getPositionDropown();
  }, []);

  const getLocation = () => {
    setLoading(true);
    ApiService.get('/checklist/location')
      .then(({ data }) => {
        var posArr = data?.data.map((pos) => { return { label: pos.location_description, value: pos.id } })
        setLocationDrop(posArr)
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      })
  }

  useEffect(() => {
    getLocation();
  }, []);

  const durationOptions = [
    { label: "Daily", value: "daily" },
    { label: "Every Other Day", value: "everyotherday" },
    { label: "Weekly", value: "weekly" },
    { label: "Bi-weekly", value: "biweekly" },
    { label: "Monthly", value: "monthly" }
  ];

  const dayOptions = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
    { label: "Everyday", value: "Everyday" }
  ];

  // Items handlers
  const addItem = () => {
    setItems([...items, { category: "", description: "", location_id: "" }]);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated.length ? updated : [{ category: "", description: "", location_id: "" }]);
  };

  const updateItem = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const getDay = () => {
    if (duration === 'daily') return 'Everyday';
    if (duration === 'monthly' || duration === 'everyotherday') return moment(date).format('YYYY-MM-DD');
    return day;
  };

  const handleSubmit = () => {
    if (!title) return toast.error("Title is required");
    if (!duration) return toast.error("Duration is required");
    if (!time) return toast.error("Time is required");

    const validItems = items.filter(i => i.category || i.description || i.location_id);

    const body = {
      title,
      duration,
      day: getDay(),
      time: moment(time).format('HH:mm:ss'),
      assignedTo: assignedTo?.value,
      position : position?.value,
      ticket_assigned_to: ticketAssignTo?.value,
      notify_checklist_update_to: checklistUpdateTo?.value,
      notify_employees: ticketNotifyTo.map(e => e.value),
      items: validItems
    };

    setLoading(true);
    ApiService.post('/checklist/add-station-inspection', body)
      .then((data) => {
        setLoading(false);
        toast.success(data.message || "Checklist added successfully");
        navigate("/firehouse/station-checklist");
      })
      .catch((error) => {
        setLoading(false);
        if (error.status === 422) {
          const errorMessages = Object.keys(error?.data?.errors || {})
            .map((err) => error.data.errors[err][0])
            .filter(Boolean);
          if (errorMessages.length) {
            toast.error(
              <div>{errorMessages.map((msg, i) => <div key={i}>• {msg}</div>)}</div>
            );
          }
        } else {
          toast.error(error?.data?.message || "Something went wrong");
        }
      });
  };

  const showDatePicker = duration === 'monthly' || duration === 'everyotherday';
  const showDayPicker = duration === 'weekly' || duration === 'biweekly';

  return (
    <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
      <Grid container spacing={2}>

        <Grid item xs={12}>
          <Typography variant="h5">
            <Link to="/firehouse/station-checklist" style={{ color: "black" }}>
              <ArrowBackIosIcon />
            </Link>
            Add Station Checklist
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Title *</label>
          <TextField
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Enter Title"
            sx={inputSx}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Duration *</label>
          <Autocomplete
            options={durationOptions}
            getOptionLabel={(option) => option.label}
            value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
            onChange={(_, newValue) => { setDuration(newValue ? newValue.value : ""); setDay(""); }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Select Duration" sx={inputSx} />
            )}
          />
        </Grid>

        {showDatePicker && (
          <Grid item xs={12} sm={6} md={4} className='d-grid'>
            <label className='my-2'>Date *</label>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <ButtonDatePicker
                className='w-100'
                label={moment(date).format('YYYY-MM-DD')}
                value={date}
                onChange={(e) => setDate(e)}
                minDate={new Date()}
              />
            </LocalizationProvider>
          </Grid>
        )}

        {showDayPicker && (
          <Grid item xs={12} sm={6} md={4}>
            <label className='my-2'>Select Day *</label>
            <Autocomplete
              options={dayOptions}
              getOptionLabel={(option) => option.label}
              value={day ? dayOptions.find(opt => opt.value === day) || null : null}
              onChange={(_, newValue) => setDay(newValue ? newValue.value : "")}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" placeholder="Select Day" sx={inputSx} />
              )}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Time *</label>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <TimePicker
              value={time}
              onChange={(newValue) => setTime(newValue)}
              sx={{ width: "100%", "& .MuiInputBase-root": { height: '48px', fontSize: '14px' } }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Assigned To</label>
          <Autocomplete
            options={employees}
            value={assignedTo}
            disabled={!!position}
            onChange={(_, newValue) => setAssignedTo(newValue)}
            sx={inputSx}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Employee" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Position</label>
          <Autocomplete
            options={positionDrop}
            value={position}
            disabled={!!assignedTo}
            onChange={(_, newValue) => setPosition(newValue)}
            sx={inputSx}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Position" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Assign Ticket To</label>
          <Autocomplete
            options={employees}
            value={ticketAssignTo}
            onChange={(_, newValue) => setTicketAssignTo(newValue)}
            sx={inputSx}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Employee" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Notify Checklist Update To</label>
          <Autocomplete
            options={employees}
            value={checklistUpdateTo}
            onChange={(_, newValue) => setChecklistUpdateTo(newValue)}
            sx={inputSx}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Employee" />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <label className='my-2'>Notify Employees</label>
          <Multiselect
            displayValue="label"
            options={employees}
            showCheckbox
            showArrow
            customCloseIcon={<img src='/images/cross.png' alt="remove" />}
            placeholder='Select Employees'
            selectedValues={ticketNotifyTo}
            onSelect={(e) => setTicketNotifyTo(e)}
            onRemove={(e) => setTicketNotifyTo(e)}
          />
        </Grid>

        <Grid item xs={12} sx={{ mt: 1 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography variant="subtitle1" fontWeight={600} color="text.secondary">
              Checklist Items
            </Typography>
            <ButtonTheme
              variant="outlined"
              color="primary"
              onClick={addItem}
              style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, padding: "6px 14px" }}
            >
              <AddCircleOutlineIcon fontSize="small" />
              Add Item
            </ButtonTheme>
          </Box>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            {items.map((item, index) => (
              <Grid item xs={12} key={index}>
                <Card variant="outlined" sx={{ borderRadius: 2, position: "relative" }}>
                  <CardContent sx={{ pb: "12px !important" }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
                      <Typography variant="body2" fontWeight={600} color="text.secondary">
                        Item #{index + 1}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => removeItem(index)}
                        sx={{ color: "#BF1D2D" }}
                        disabled={items.length === 1}
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={4}>
                        <label className='my-2' style={{ fontSize: 13 }}>Parent Station*</label>
                        <Autocomplete
                          options={locationDrop}
                          getOptionLabel={(option) => option.label}
                          value={item.location_id ? locationDrop.find(opt => opt.value === item.location_id) || null : null}
                          onChange={(_, newValue) => updateItem(index, "location_id", newValue?.value || "")}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Location"
                              variant="outlined"
                              fullWidth
                              size="small"
                              sx={inputSx}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <label className='my-2' style={{ fontSize: 13 }}>Category</label>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="e.g. Exterior & Grounds"
                          value={item.category}
                          onChange={(e) => updateItem(index, "category", e.target.value)}
                          sx={inputSx}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <label className='my-2' style={{ fontSize: 13 }}>Description</label>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Enter item description"
                          value={item.description}
                          onChange={(e) => updateItem(index, "description", e.target.value)}
                          sx={inputSx}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item container xs={12} gap={2} sx={{ mt: 1 }}>
          <ButtonTheme
            variant="filled"
            color="primary"
            className='px-5'
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Saving..." : "Add"}
          </ButtonTheme>
          <Link to="/firehouse/station-checklist">
            <ButtonTheme variant="filled" className='px-5' color='#D0D5DD'>
              Cancel
            </ButtonTheme>
          </Link>
        </Grid>

      </Grid>
    </Paper>
  );
};

export default AddStationChecklist;
